import { render, staticRenderFns } from "./AddDistributorModal.vue?vue&type=template&id=ba212194&scoped=true&"
import script from "./AddDistributorModal.vue?vue&type=script&lang=js&"
export * from "./AddDistributorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDistributorModal.vue?vue&type=style&index=0&id=ba212194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba212194",
  null
  
)

export default component.exports